import { gql } from '@apollo/client'

export const WEEKLY_PLAN_QUERY = gql`
  query weeklyPlan($calendarWeek: Int!, $year: Int!) {
    weeklyPlan(calendarWeek: $calendarWeek, year: $year) {
      id
      calendarWeek
      year
      status
      notes
      weekStartDate
      weekEndDate
      totalMediators
      totalConfirmed
      createdBy {
        id
        firstname
        lastname
      }
      weeklyAvailabilities {
        id
        canEdit
        team {
          id
          title
          parentTeam {
            id
            title
          }
        }
        teams {
          id
          title
        }
        user {
          id
          firstname
          lastname
          email
          phoneNumber
          mobileNumber
          languages
          mediatorProfile {
            distributionCategory
            preferredTopics
            acceptableTopics
            excludedTopics
            minCasesPerWeek
            maxCasesPerWeek
            hoursPerWeek
            workingDaysPerWeek
            canDoPresence
            isSpecialist
            specialNotes
            mediatorTags {
              id
              name
              slug
            }
          }
        }
        confirmationStatus
        notes
        totalAssignments
        totalHours
        contractualHours
        trackedHours
        workingTime {
          monday
          tuesday
          wednesday
          thursday
          friday
          hoursPerWeek
        }
        availabilitySlots {
          id
          weekday
          startTime
          endTime
          slotType
          durationHours
        }
        allowedSlotKinds {
          name
          slug
          color
          sortOrder
          isAbsence
          assignableForNewCases
        }
        weeklyAssignments {
          id
          weekday
          processingId
        }
        trackedHoursPerDay
        weeklyCaseQuota {
          totalMin
          totalMax
          days {
            weekday
            minCases
            maxCases
            minSource
            maxSource
          }
        }
      }
      weeklyPlanTeamSubmissions {
        id
        weeklyPlanId
        teamId
        status
        canSubmit
        submittedAt
        reviewedAt
        reviewNote
        submittedBy {
          id
          firstname
          lastname
        }
        reviewedBy {
          id
          firstname
          lastname
        }
        team {
          id
          title
          subteams {
            id
            title
          }
          users {
            id
            firstname
            lastname
          }
        }
      }
    }
  }
`

export const MY_WEEKLY_AVAILABILITY_QUERY = gql`
  query myWeeklyAvailability($calendarWeek: Int!, $year: Int!) {
    myWeeklyAvailability(calendarWeek: $calendarWeek, year: $year) {
      planId
      planStatus
      calendarWeek
      year
      weekStartDate
      weekEndDate
      allowedSlotKinds {
        slug
        name
        color
        sortOrder
        isAbsence
        assignableForNewCases
      }
      availability {
        id
        canEdit
        confirmationStatus
        notes
        totalAssignments
        totalHours
        contractualHours
        trackedHours
        workingTime {
          monday
          tuesday
          wednesday
          thursday
          friday
          hoursPerWeek
        }
        availabilitySlots {
          id
          weekday
          startTime
          endTime
          slotType
          durationHours
        }
        weeklyAssignments {
          id
          weekday
          processingId
        }
        trackedHoursPerDay
        allowedSlotKinds {
          slug
          name
          color
          sortOrder
          isAbsence
          assignableForNewCases
        }
      }
    }
  }
`

export const WEEKLY_PLANS_QUERY = gql`
  query weeklyPlans($year: Int, $status: WeeklyPlanStatusEnum) {
    weeklyPlans(year: $year, status: $status) {
      id
      calendarWeek
      year
      status
      totalMediators
      totalConfirmed
    }
  }
`

export const ASSIGNABLE_USERS_FOR_PLAN_QUERY = gql`
  query assignableUsersForPlan($weeklyPlanId: ID!) {
    assignableUsersForPlan(weeklyPlanId: $weeklyPlanId) {
      id
      firstname
      lastname
      email
    }
  }
`

export const USERS_WITHOUT_AVAILABILITY_QUERY = gql`
  query usersWithoutAvailability($calendarWeek: Int!, $year: Int!) {
    usersWithoutAvailability(calendarWeek: $calendarWeek, year: $year) {
      id
      firstname
      lastname
      email
    }
  }
`

export const MEDIATOR_TAGS_QUERY = gql`
  query mediatorTags {
    mediatorTags {
      id
      name
      slug
      description
    }
  }
`

export const LEADERSHIP_TEAMS_QUERY = gql`
  query leadershipTeams {
    leadershipTeams {
      id
      title
      parentTeam {
        id
        title
      }
      leader {
        id
        firstname
        lastname
      }
      activeMembers {
        id
        firstname
        lastname
      }
    }
  }
`
